import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import StatusBadge from '../../components/StatusBadge/StatusBadge';
import ListaHistoricoHardware from '../../components/ListaHistoricoHardware/ListaHistoricoHardware';
import HardwareFotosCondicaoModal from '../../components/HardwareFotosCondicaoModal/HardwareFotosCondicaoModal';
import CmdbHardware from '../../components/CmdbHardware/CmdbHardware';
import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';
import '../../styles/inventario.css';
import './DetalheHardware.css';

function DetalheHardware() {
    const { id } = useParams();
    const history = useHistory();
    const [asset, setAsset] = useState(null);
    const [assignment, setAssignment] = useState(null);
    const [historyList, setHistoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showFotosModal, setShowFotosModal] = useState(false);

    const verificar = useCallback(async () => {
        const resultado = await verificandoApp('ATENDENTE');
        if (!resultado) history.push('/');
    }, [history]);

    const fetchAsset = useCallback(async (codHar) => {
        if (!codHar) return null;
        verificandoToken();
        const token = localStorage.getItem('token');
        const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/hardware/espec', {
            headers: { Authorization: `${token}` },
            params: { codHar }
        });
        if (response.data && response.data.length > 0) {
            const r = response.data[0];
            return {
                codhar: r.codhar ?? r.CODHAR,
                codeqp: r.codeqp ?? r.CODEQP,
                sereqp: (r.sereqp ?? r.SEREQP ?? '').toString(),
                pateqp: (r.pateqp ?? r.PATEQP ?? '').toString(),
                deseqp: (r.deseqp ?? r.DESEQP ?? '').toString(),
                siteqp: (r.siteqp ?? r.SITEQP ?? '').toString()
            };
        }
        return null;
    }, []);

    const fetchAssignment = useCallback(async (codHar) => {
        if (!codHar) return null;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/vinculacao/hardware', {
                headers: { Authorization: `${token}` },
                params: { codHar }
            });
            if (response.data && response.data.length > 0) {
                const r = response.data[0];
                return {
                    codUsu: r.CODUSU ?? r.codUsu,
                    nomUsu: (r.USRNOMCPL ?? r.usrnomcpl ?? '').toString(),
                    seqVin: r.SEQVIN ?? r.seqVin
                };
            }
        } catch (e) {

        }
        return null;
    }, []);

    const fetchHistory = useCallback(async (codHar) => {
        if (!codHar) return [];
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/hishardware/hardware', {
                headers: { Authorization: `${token}` },
                params: { codHar }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            return raw.map((r) => ({
                codhar: r.codhar ?? r.CODHAR,
                deshis: r.deshis ?? r.DESHIS ?? '',
                seqhis: r.seqhis ?? r.SEQHIS,
                dathis: r.dathis ?? r.DATHIS ?? ''
            }));
        } catch (e) {
            return [];
        }
    }, []);

    const loadAll = useCallback(async () => {
        if (!id) {
            setError('Código do hardware não informado.');
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const [assetData, assignmentData, historyData] = await Promise.all([
                fetchAsset(id),
                fetchAssignment(id),
                fetchHistory(id)
            ]);
            if (!assetData) {
                setError('Hardware não encontrado.');
                setAsset(null);
                setAssignment(null);
                setHistoryList([]);
            } else {
                setAsset(assetData);
                setAssignment(assignmentData);
                setHistoryList(historyData);
            }
        } catch (e) {
            setError('Erro ao carregar dados.');
            setAsset(null);
            setAssignment(null);
            setHistoryList([]);
        } finally {
            setLoading(false);
        }
    }, [id, fetchAsset, fetchAssignment, fetchHistory]);

    useEffect(() => {
        verificar();
    }, [verificar]);

    useEffect(() => {
        loadAll();
    }, [loadAll]);

    const hasAssignment = assignment != null && (assignment.nomUsu || assignment.codUsu);

    if (loading) {
        return (
            <div className="app-layout">
                <Sidebar />
                <main className="main-content">
                    <div className="container-fluid titulo cadastro-unificado">
                        <p className="text-muted">Carregando...</p>
                    </div>
                </main>
            </div>
        );
    }

    if (error && !asset) {
        return (
            <div className="app-layout">
                <Sidebar />
                <main className="main-content">
                    <div className="container-fluid titulo cadastro-unificado">
                        <div className="alert alert-warning">{error}</div>
                        <Link to="/listaHardware" className="btn btn-secondary">Voltar ao Inventário</Link>
                    </div>
                </main>
            </div>
        );
    }

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                <div className="container-fluid titulo cadastro-unificado inventario-page detalhe-hardware">
                    <div className="detalhe-hardware__header">
                        <Link to="/listaHardware" className="btn btn-outline-secondary btn-sm mb-2">
                            <i className="fas fa-arrow-left" /> Voltar ao Inventário
                        </Link>
                        <h1 className="detalhe-hardware__titulo">Ativo #{asset.codhar}</h1>
                        <div className="detalhe-hardware__actions">
                            <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => history.push({ pathname: '/listaHardware', state: { editId: asset.codhar } })}
                                title="Editar"
                            >
                                <i className="fas fa-edit" /> Editar
                            </button>
                            <Link to={`/novoHisHar/${asset.codhar}`} className="btn btn-outline-primary btn-sm" title="Documentar manutenção">
                                <i className="fas fa-file-alt" /> Documentar
                            </Link>
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => setShowFotosModal(true)} title="Fotos da condição do equipamento">
                                <i className="fas fa-camera" /> Fotos
                            </button>
                            {!hasAssignment && (
                                <Link to={`/novoVinculo/${asset.codhar}`} className="btn btn-outline-primary btn-sm" title="Vincular">
                                    <i className="fas fa-link" /> Vincular
                                </Link>
                            )}
                            {hasAssignment && (
                                <Link to={`/novoDesvinculo/${asset.codhar}`} className="btn btn-outline-secondary btn-sm" title="Desvincular">
                                    <i className="fas fa-unlink" /> Desvincular
                                </Link>
                            )}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card card-form mb-3">
                                <div className="card-header">
                                    <h5 className="mb-0">Informações do ativo</h5>
                                </div>
                                <div className="card-body">
                                    <dl className="row mb-0">
                                        <dt className="col-sm-4">Código</dt>
                                        <dd className="col-sm-8">{asset.codhar}</dd>
                                        <dt className="col-sm-4">Série</dt>
                                        <dd className="col-sm-8">{asset.sereqp || '—'}</dd>
                                        <dt className="col-sm-4">Equipamento (cód.)</dt>
                                        <dd className="col-sm-8">{asset.codeqp || '—'}</dd>
                                        <dt className="col-sm-4">Patrimônio</dt>
                                        <dd className="col-sm-8">{asset.pateqp || '—'}</dd>
                                        <dt className="col-sm-4">Descrição</dt>
                                        <dd className="col-sm-8" style={{ whiteSpace: 'pre-wrap' }}>{asset.deseqp || '—'}</dd>
                                        <dt className="col-sm-4">Status</dt>
                                        <dd className="col-sm-8">
                                            <StatusBadge siteqp={asset.siteqp} comVinculo={hasAssignment} />
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="card card-form mb-3">
                                <div className="card-header">
                                    <h5 className="mb-0">Atribuição atual</h5>
                                </div>
                                <div className="card-body">
                                    {hasAssignment ? (
                                        <p className="mb-0">
                                            <i className="fas fa-user text-muted" /> {assignment.nomUsu || `Usuário ${assignment.codUsu}`}
                                        </p>
                                    ) : (
                                        <p className="mb-0 text-muted">Sem vínculo ativo</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <CmdbHardware codhar={asset.codhar} patrimonio={asset.pateqp} descricao={asset.deseqp} />

                    <div className="card card-form mb-3">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">Histórico</h5>
                            <Link to={`/listaHisHar/${asset.codhar}`} className="btn btn-sm btn-outline-secondary">Ver em tela cheia</Link>
                        </div>
                        <div className="card-body p-0">
                            {historyList.length === 0 ? (
                                <p className="p-3 mb-0 text-muted">Nenhum registro de histórico.</p>
                            ) : (
                                <ListaHistoricoHardware arrayHistoricoHardware={historyList} />
                            )}
                        </div>
                    </div>
                    <HardwareFotosCondicaoModal
                        isOpen={showFotosModal}
                        onClose={() => setShowFotosModal(false)}
                        codHar={asset.codhar}
                        label={[asset.sereqp, asset.pateqp ? `Pat. ${asset.pateqp}` : ''].filter(Boolean).join(' ') || `#${asset.codhar}`}
                    />
                </div>
            </main>
        </div>
    );
}

export default DetalheHardware;
